import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from "react-router-dom";
import * as types from '../../constants/actionTypes';
import PharmacyHeader from './PharmacyHeader';
import SectionLoading from '../common/SectionLoading';
import SectionLoadingError from '../common/SectionLoadingError';
import PickupLocation from './PickupLocation';
import { firstNameFirst, rxRoute } from "../../helpers/formatting";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class PickupDetails extends React.Component {
    constructor(props, params) {
        super(props, params);
        this.loadData = this.loadData.bind(this);
        this.state = { dataLoaded: false };
    }

    componentDidMount() {
        this.setState({ dataLoaded: false });
        this.loadData();
        logUI("MBHWeb.UI.Rx.PickupDetails.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.loadData();
    }

    loadData() {
        const { hasPharmacyLogin, currentPharmacyUser, storeNumber, getReadyForPickup, isLoggedIn, userDetails } = this.props;
        if (!this.state.dataLoaded && isLoggedIn && (hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId)) && storeNumber) {
            this.setState({ dataLoaded: true });
            getReadyForPickup(storeNumber, userDetails);
        }
    }

    render() {
        const { waitingOnReadyForPickup, readyForPickupError, readyForPickupList, readyForPickupPharmacy, readyForPickupTotalCost } = this.props;
        return (
            <div className="container-fluid body-content pharmacy-home-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <PharmacyHeader />
                            {waitingOnReadyForPickup === true ?
                                <div className="col-12">
                                    <SectionLoading />
                                </div>:
                                readyForPickupError ?
                                    <SectionLoadingError message="We're not able to display pickup details. Please try again later." /> :
                                    readyForPickupList &&
                                    <div className="col-12">
                                        <div className="row rx-pickup-details">
                                            <div className="col-12 col-md-7">
                                                <h2 className="h5 main">Prescriptions:</h2>
                                                {!readyForPickupList || readyForPickupList.length === 0 ?
                                                    <div>There are no prescriptions for pickup.</div> :
                                                    readyForPickupList.map((rx, index) =>
                                                        <div key={index} className="row rx-ready">
                                                            <div className="col-12">
                                                                <div className="rx-img-container">
                                                                    <img alt={rx.rxDrugName + " photo"} src={rx.NDCImageURL ? rx.NDCImageURL : '/images/prescription_placeholder.jpg'} className="img-fluid" />
                                                                </div>
                                                                <div className="rx-info-container">
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <Link to={{ pathname: `${rxRoute('rxDetail')}/${rx.storeNumber}/${rx.rxNumber}` }}>
                                                                                <h3 className="h5 rx-name">{rx.rxDrugName}</h3>
                                                                                <h3 className="h5 rx-number">RX No. {rx.rxNumber}</h3>
                                                                            </Link>
                                                                            <div>{rx.RefillsUntilExpiry ? rx.RefillsUntilExpiry : '-'}</div>
                                                                            <div>
                                                                                {rx.PrescriberName ? `Prescribed by ${firstNameFirst(rx.PrescriberName)}: ` : '-'}
                                                                                {rx.PrescriberContactNumber ? rx.PrescriberContactNumber : '-'}
                                                                            </div>
                                                                            <div>{rx.RxSig ? rx.RxSig : '-'}</div>
                                                                            <div>Estimated Cost: ${parseFloat(rx.patientPay).toFixed(2)}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <PickupLocation containerClass="col-12 col-md-5 rx-pickup-loc" pharmacy={readyForPickupPharmacy} showOperationHours />
                                            <div className="col-12 rx-estimate">Total Estimated Cost: <span className="rx-estimate__cost">${parseFloat(readyForPickupTotalCost).toFixed(2)}</span></div>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        storeNumber: ownProps && ownProps.match ? ownProps.match.params.storeNumber : "",
        readyForPickupList: state.pharmacy.readyForPickupList,
        readyForPickupPharmacy: state.pharmacy.readyForPickupPharmacy,
        readyForPickupTotalCost: state.pharmacy.readyForPickupTotalCost,
        waitingOnReadyForPickup: state.pharmacy.waitingOnReadyForPickup,
        readyForPickupError: state.pharmacy.readyForPickupError, 
        isLoggedIn: state.sso.isLoggedIn, 
        userDetails: state.sso.userDetails,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReadyForPickup: (storeNumber, userDetails) => {
            dispatch({
                type: types.RX_READY_FOR_PICKUP,
                storeNumber: storeNumber,
                userDetails: userDetails
            });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PickupDetails));